import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { CategoryList } from './CategoryList';
import { useT } from '../i18n/useT';
/**
 * A `categories` modul okos wrapper-e. Ha enabled=false vagy nincs highlight kategoria,
 * akkor a sima CategoryList renderelodik (jelenlegi viselkedes). Ha van, akkor:
 *
 * - Initial state (selectedId == null): a highlight kategoriak jelennek meg pillek-kent
 *   (CategoryList-be passzolva mint Category[] color+highlightSlug-gel)
 * - Selected state (selectedId > 0): "Vissza" gomb + a kivalasztott highlight sub_counts > 0
 *   kategoriai (count = sub_count) — ugyanezen CategoryList design.
 *
 * A wrapper-on belul a CategoryList tobbszor renderelodik kulonbozo Category[]-vel —
 * a CategoryList maga "buta" presentational komponens marad, az allapotot a wrapper kezeli.
 */
export function CategoryListWithHighlights({ categories, highlightCategories, enabled, mode, onCategorySelect, onHighlightFilter, selectedMainId, }) {
    const { t } = useT();
    const [selectedId, setSelectedId] = useState(null);
    // [B-HLPILLNOFILTER] A szulo kiemelt fo-kategoriaja (URL-bol indulo kereses, pill, Vissza,
    // kereso-legordulo) az egyetlen igazsag: a pill-nezet KETIRANYUAN koveti (>0 -> kinyitott
    // al-kategoria nezet, 0 -> kezdo nezet), igy a lista szuroje es a pillek allapota nem valhat
    // szet. Ha a prop nincs megadva (undefined), a lokalis state onalloan mukodik. A nem letezo
    // id-t a kinyitott ag vedelme (selected hianya -> kezdo nezet) kezeli.
    useEffect(() => {
        if (selectedMainId === undefined)
            return;
        setSelectedId(selectedMainId > 0 ? selectedMainId : null);
    }, [selectedMainId]);
    // Highlight mode kikapcsolva (admin toggle OFF vagy ures lista) → regular CategoryList
    if (!enabled || !highlightCategories || highlightCategories.length === 0) {
        return _jsx(CategoryList, { categories: categories, mode: mode, onSelect: onCategorySelect });
    }
    // Selected highlight → Back gomb az ELSO kategoria-pill helyen + sub-kategoriak (ugyanaz a design)
    // [B-HLPILLNOFILTER] (academy #2260, digic) A kiemelt pill kattintasa a FO-kategoriara szuri a
    // listat (onHighlightFilter(id, 0) -> maincategory), a sub-cat click tovabb szukit (main AND sub),
    // a Vissza gomb torli a kategoria-szurot (onHighlightFilter(0, 0)). Korabban (a26b20af92) a pill
    // es a Vissza tiszta UI-navigacio volt: al-kategoria nelkuli kiemeltnel (egy-kategorias allasok)
    // csak a Vissza gomb jelent meg, alatta a SZURETLEN teljes lista - az ugyfel ezt "rossz
    // kategoria alatt megjeleno hirdetesnek" latta.
    if (selectedId !== null) {
        const selected = highlightCategories.find(hc => hc.id === selectedId);
        if (!selected) {
            // Vedelem: ha kozben eltunt (admin save?), vissza initial state-re
            setSelectedId(null);
            return null;
        }
        // sub_counts az ID => count map; a "valodi" kategoria nev + image a `categories` tombbol jon
        const subCats = categories
            .filter(c => (selected.sub_counts[c.id] || 0) > 0)
            .map(c => ({
            ...c,
            count: selected.sub_counts[c.id],
        }));
        // A "Vissza" gomb a CategoryList `leadingItem`-jeben — igy egy sorban renderelodik a
        // tobbi kategoria-pillel, ugyanazokat a stilusokat orokli. Markup szerkezetileg azonos
        // egy normal kategoria-pillel (career-category-pill class), csak <button> + back class.
        // Click: vissza a kiemelt pillekhez ES a kategoria-szuro torlese (0, 0) - igy a pillek
        // "minden kategoria" allapota es a lista egyutt mozog (a tobbi szuro megmarad).
        const backItem = (_jsx("button", { type: "button", className: "career-category-pill career-category-pill-back", onClick: () => {
                setSelectedId(null);
                onHighlightFilter(0, 0);
            }, "data-translate": "highlight_back_label", children: _jsxs("span", { className: "career-category-pill-name", children: ["\u2190 ", t('highlight_back_label', 'Vissza')] }) }));
        return (_jsx(CategoryList, { categories: subCats, mode: mode, 
            // Sub-cat click EZ AZ EGYETLEN actio ami job filter-t triggerel: maincategory + category
            onSelect: (subId) => onHighlightFilter(selectedId, subId), leadingItem: backItem }));
    }
    // Initial state: a highlight kategoriak mint Category[] (color + key + image set)
    const highlightAsCats = highlightCategories.map(hc => ({
        id: hc.id,
        name: hc.name,
        image: hc.image,
        count: hc.count,
        color: hc.color,
        highlightSlug: hc.key,
    }));
    return (_jsx(CategoryList, { categories: highlightAsCats, mode: mode, 
        // [B-HLPILLNOFILTER] a kiemelt pill click: al-kategoria nezet + szures a fo-kategoriara
        // (maincategory=id). Al-kategoria nelkuli kiemeltnel igy is a kiemelt sajat allasai
        // latszanak, nem a teljes lista.
        onSelect: (highlightId) => {
            setSelectedId(highlightId);
            onHighlightFilter(highlightId, 0);
        } }));
}
